import { Connection, EntityManager, getConnection, getManager, QueryRunner, Repository } from 'typeorm';
import { Inject, Injectable } from '@nestjs/common';
import { ITransactionHelper } from './itransaction-helper';
import { IsolationLevel } from 'typeorm/driver/types/IsolationLevel';

@Injectable()
export class GenericTransactionManager implements ITransactionHelper  {
    private readonly dbConn: Connection;
    private readonly queryRunner: QueryRunner;
    private transactionManager: EntityManager;

    constructor() {
      // this.dbConn = connection;
      // getting a connection from the connection pool;
      this.queryRunner = getConnection().createQueryRunner();
    }

    setTransactionManager() {
      this.transactionManager = this.queryRunner.manager;
    }


    async startTransaction(isolationLevel?: IsolationLevel) {
      await this.queryRunner.startTransaction(isolationLevel ? isolationLevel : 'READ COMMITTED');
      this.setTransactionManager();
    }

    getRepository<T>(RandomEntity: new (transactionManager: EntityManager) => T): Repository<T> {
      if (!this.transactionManager) {
        throw new Error('Requesting repository in a transaction scope without starting the transaction');
      }
      return this.transactionManager.getRepository(RandomEntity);
    }

    getCustomRepository<T extends Repository<any>>(RandomEntity: new (transactionManager: EntityManager) => T): T {
        if (!this.transactionManager) {
          throw new Error('Requesting custom repository in a transaction scope without starting the transaction');
        }
        return this.transactionManager.getCustomRepository(RandomEntity);
    }

    async completeTransaction() {
      try {
        await this.queryRunner.commitTransaction();
      } catch (error) {
        await this.queryRunner.rollbackTransaction();
        throw error;
      } finally {
        await this.queryRunner.release();
      }
    }

    async releaseTransaction() {
      if(this.queryRunner.isTransactionActive) {

      await this.queryRunner.rollbackTransaction();
      await this.queryRunner.release();
      }
    }
  }